export const ACCESSIBILITY_PREFS_VERSION = 6
export const UI_SCALE_MIN = 0.6
export const UI_SCALE_MAX = 1.4

export const ACCESSIBILITY_CAPABILITIES = Object.freeze([
  { id: 'ui-scale', label: 'Масштаб интерфейса и текста', supported: true, source: 'ClientPrefs.ui + CoreUI root rem scale' },
  { id: 'high-contrast', label: 'Повышенный контраст интерфейса', supported: true, source: 'theme tokens + CoreUI contrast/focus variant' },
  { id: 'reduced-motion', label: 'Уменьшенное движение', supported: true, source: 'CoreUI motion policy + ClientGraphics effective postprocessing' },
  { id: 'input-hints', label: 'Подсказки управления', supported: true, source: 'ClientPrefs.actions + keyboard/gamepad/touch UI' },
  { id: 'audio-buses', label: 'Общая громкость, музыка, эффекты и голоса', supported: true, source: 'ClientAudio Web Audio gain buses' },
  { id: 'keyboard-focus', label: 'Клавиатурный фокус и ARIA', supported: true, source: 'browser focus + shared screen components' },
  { id: 'captions', label: 'Субтитры и live captions', supported: false, source: null },
  { id: 'screen-reader-engine', label: 'Встроенный screen-reader engine', supported: false, source: null },
  { id: 'input-remapping', label: 'Переназначение управления', supported: false, source: null },
  { id: 'colorblind-shader', label: 'Шейдеры цветовой коррекции', supported: false, source: null },
  { id: 'camera-shake', label: 'Управление тряской камеры', supported: false, source: null },
])

const finite = (value, fallback) => Number.isFinite(Number(value)) ? Number(value) : fallback
export const clampUIScale = value => Math.min(UI_SCALE_MAX, Math.max(UI_SCALE_MIN, finite(value, 1)))
export const clampVolume = value => Math.min(1, Math.max(0, finite(value, 1)))

export function accessibilityDefaults({ touch = false, prefersReducedMotion = false } = {}) {
  return {
    ui: touch ? 0.9 : 1,
    actions: true,
    highContrast: false,
    reduceMotion: Boolean(prefersReducedMotion),
    master: 1,
  }
}

export function normalizeAccessibilityPrefs(data = {}, env = {}) {
  const defaults = accessibilityDefaults(env)
  return {
    ui: clampUIScale(data.ui ?? defaults.ui),
    actions: typeof data.actions === 'boolean' ? data.actions : defaults.actions,
    highContrast: typeof data.highContrast === 'boolean' ? data.highContrast : defaults.highContrast,
    reduceMotion: typeof data.reduceMotion === 'boolean' ? data.reduceMotion : defaults.reduceMotion,
    master: clampVolume(data.master ?? defaults.master),
  }
}

export function accessibilitySnapshot(prefs) {
  const normalized = normalizeAccessibilityPrefs(prefs)
  return {
    ...normalized,
    capabilities: ACCESSIBILITY_CAPABILITIES.map(item => ({ ...item })),
  }
}

export function applyAccessibilityToElement(element, prefs) {
  if (!element) return
  const value = normalizeAccessibilityPrefs(prefs)
  element.dataset.testcsContrast = value.highContrast ? 'high' : 'standard'
  element.dataset.testcsMotion = value.reduceMotion ? 'reduced' : 'full'
  element.dataset.testcsInputHints = value.actions ? 'visible' : 'hidden'
  element.style.setProperty('--testcs-ui-scale', String(value.ui))
  element.style.setProperty('--testcs-motion-factor', value.reduceMotion ? '0' : '1')
}
